import React from 'react';
import { ErrorLogicTable } from '@components/error-logic-config';
import { ContentWrapper } from '../styled';

function Content() {
  return (
    <ContentWrapper>
      <ErrorLogicTable />
    </ContentWrapper>
  );
}

export default Content;
